"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerListItem = PlayerListItem;
const React = __importStar(require("react"));
const react_1 = require("react");
const ui_1 = require("@creature-chess/ui");
const BalanceIcon_1 = require("~/components/ui/icon/BalanceIcon");
const LevelIcon_1 = require("~/components/ui/icon/LevelIcon");
const PositionChip_1 = require("~/components/ui/player/PositionChip");
const useStyles_1 = require("~/useStyles");
const models_1 = require("@creature-chess/models");
const useOnClickOutside_1 = require("../../../hooks/useOnClickOutside");
const player_1 = require("../../ui/player");
const streakIndicator_1 = require("./streakIndicator");
function getBattleWin(battle) {
    if (!battle) {
        return false;
    }
    if (battle.status !== models_1.PlayerBattleStatus.FINISHED) {
        return false;
    }
    const { isHomePlayer, homeScore, awayScore } = battle;
    return isHomePlayer ? homeScore > awayScore : awayScore > homeScore;
}
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    container: {
        containerName: "player-list-item",
        containerType: "inline-size",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        background: "#343c4e",
        padding: "6px 8px 6px 6px",
        borderStyle: "solid",
        borderRadius: "10px",
        borderColor({ isLocal, isOpponent, currentlySpectating }) {
            return isLocal
                ? "#ec5d6e"
                : (isOpponent
                    ? "#f0a23a"
                    : (currentlySpectating
                        ? "#4ee1eb"
                        : "rgba(255, 255, 255, 0.05)"));
        },
        borderWidth({ isLocal, isOpponent, currentlySpectating }) {
            return (isLocal || isOpponent || currentlySpectating) ? "2px" : "1px";
        },
        borderLeftWidth({ isLocal, isOpponent, currentlySpectating }) {
            return (isLocal || isOpponent || currentlySpectating) ? "4px" : "1px";
        },
        boxShadow({ isOpponent }) {
            return isOpponent ? "0 0 0 1px rgba(240,162,58,.25),0 0 12px rgba(240,162,58,.16)" : "none";
        },
    },
    avatar: {
        "width": "38px",
        "height": "38px",
        "@container player-list-item (min-width: 360px)": {
            width: "48px",
            height: "48px",
        },
    },
    readyIndicator: {
        width: "5px",
        // would be nice to use height: "100%" here, but it doesn't work with flexbox
        height: "38px",
        borderRadius: "3px",
        background({ player: { ready }, showReadyIndicator = false }) {
            return (ready && showReadyIndicator ? "#46c45a" : "#495267");
        },
        boxShadow({ player: { ready }, showReadyIndicator = false }) {
            return (ready && showReadyIndicator ? "0 0 6px rgba(70,196,90,.55)" : "none");
        }
    },
    details: {
        "flex": 1,
        "display": "flex",
        "flexDirection": "column",
        // tighten up the gap if the player has a title. also, increase the gap for larger screens
        gap({ player }) {
            var _a;
            if ((_a = player.profile) === null || _a === void 0 ? void 0 : _a.title) {
                return "2px";
            }
            return "4px";
        },
        "@container player-list-item (min-width: 360px)": {
            gap({ player }) {
                var _a;
                if ((_a = player.profile) === null || _a === void 0 ? void 0 : _a.title) {
                    return "2px";
                }
                return "8px";
            },
        },
        "& > div": {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            height: "1em",
        },
    },
    name: {
        "flex": 3,
        "color": theme.palette.light.neutral,
        "fontSize": "16px",
        "@container player-list-item (min-width: 360px)": {
            fontSize: "18px",
        },
    },
    healthbar: {
        flex: 2,
    },
    titleContainer: {
        marginTop: "-2px",
    },
    stats: {
        "display": "flex",
        "alignItems": "center",
        "flexShrink": 0,
        "gap": "6px",
        "& > div": {
            display: "flex",
        },
    },
    battle: {
        "flex": 1,
        "display": "flex",
        "justifyContent": "flex-end",
        "alignItems": "center",
        "& > span": {
            "fontSize": "12px",
            color({ player: { battle } }) {
                if (!battle) {
                    return "#ccc";
                }
                if (battle.status === models_1.PlayerBattleStatus.IN_PROGRESS) {
                    return "#ffcd74";
                }
                return getBattleWin(battle) ? "#38b764" : "#b13e53";
            },
            "display": "flex",
            "alignItems": "center",
            "gap": "2px",
            "background": "rgb(51, 51, 51)",
            "padding": "2px 4px",
            "@container player-list-item (min-width: 360px)": {
                fontSize: "16px",
            }
        },
    },
    position: {
        fontSize: "10px",
    },
    levelIcon: {
        "gap": "2px",
        "padding": "2px 4px",
        "fontSize": "12px",
        "@container player-list-item (min-width: 360px)": {
            fontSize: "14px",
        },
    },
    balanceIcon: {
        "gap": "2px",
        "letterSpacing": "1px",
        "fontSize": "12px",
        "@container player-list-item (min-width: 360px)": {
            fontSize: "14px",
        },
    },
    streakIndicator: {
        "width": "16px",
        "@container player-list-item (min-width: 360px)": {
            width: "18px",
        },
        "boxShadow": "none",
    }
}));
function BattleText({ battle, opponentName }) {
    if (!battle) {
        return null;
    }
    if (battle.status === models_1.PlayerBattleStatus.IN_PROGRESS) {
        return (React.createElement("span", null,
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" },
                React.createElement("path", { d: "M21 3v5l-11 9l-4 4l-3 -3l4 -4l9 -11l5 0" }),
                React.createElement("path", { d: "M5 13l6 6" }),
                React.createElement("path", { d: "M14.32 17.32l3.68 3.68l3 -3l-3.365 -3.365" }),
                React.createElement("path", { d: "M10 5.5l-2 -2.5h-5v5l3 2.5" })),
            opponentName));
    }
    if (battle.status === models_1.PlayerBattleStatus.FINISHED) {
        const win = getBattleWin(battle);
        return (React.createElement("span", null,
            React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, win
                ? (React.createElement(React.Fragment, null,
                    React.createElement("path", { d: "M17 7l-10 10" }),
                    React.createElement("path", { d: "M8 7l9 0l0 9" }))) : (React.createElement(React.Fragment, null,
                React.createElement("path", { d: "M7 7l10 10" }),
                React.createElement("path", { d: "M17 8l0 9l-9 0" })))),
            opponentName,
            " (",
            battle.homeScore,
            " - ",
            battle.awayScore,
            ")"));
    }
    return null;
}
function PlayerListItem(props) {
    var _a, _b;
    const styles = useStyles(props);
    const { index, player, opponentName, isLocal, onSpectateClick, currentlySpectating = false, } = props;
    const ref = (0, react_1.useRef)(null);
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(false);
    (0, useOnClickOutside_1.useOnClickOutside)(ref, () => setIsExpanded(false));
    const toggleExpanded = () => {
        // don't open for local player
        if (isLocal) {
            return;
        }
        setIsExpanded(!isExpanded);
    };
    return (React.createElement("div", { className: styles.container, onClick: toggleExpanded, ref: ref },
        React.createElement(PositionChip_1.PositionChip, { position: index + 1, className: styles.position }),
        React.createElement(player_1.PlayerAvatar, { player: player, className: styles.avatar }),
        React.createElement("div", { className: styles.readyIndicator }),
        React.createElement("div", { className: styles.details },
            React.createElement("div", null,
                React.createElement("div", { className: styles.name },
                    React.createElement("span", null, player.name)),
                React.createElement("div", { className: styles.healthbar },
                    React.createElement(player_1.PlayerHealthbar, { health: player.health }))),
            ((_a = player.profile) === null || _a === void 0 ? void 0 : _a.title) && (React.createElement("div", { className: styles.titleContainer },
                React.createElement(player_1.Title, { title: ((_b = player.profile) === null || _b === void 0 ? void 0 : _b.title) || null }))),
            React.createElement("div", null,
                React.createElement("div", { className: styles.stats },
                    React.createElement("div", null,
                        React.createElement(BalanceIcon_1.BalanceIcon, { amount: player.money, className: styles.balanceIcon })),
                    React.createElement("div", null,
                        React.createElement(LevelIcon_1.LevelIcon, { amount: player.level, className: styles.levelIcon, label: false })),
                    player.streakType !== null
                        && player.streakAmount !== null
                        && player.streakAmount > 1
                        && (React.createElement("div", null,
                            React.createElement(streakIndicator_1.StreakIndicator, { type: player.streakType, amount: player.streakAmount, className: styles.streakIndicator })))),
                React.createElement("div", { className: styles.battle }, (currentlySpectating || isExpanded)
                    ? (React.createElement(ui_1.Button, { color: "primary", size: "xsmall", onClick: onSpectateClick }, currentlySpectating ? "Stop Spectating" : "Spectate"))
                    : React.createElement(BattleText, { battle: player.battle, opponentName: opponentName }))))));
}
